import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { noticeContent } from "@/data/noticeContent";
import { NoticeBody } from "@/components/NoticeBody";

const ease = [0.22, 1, 0.36, 1];

export const ServiceNotice = () => {
  const { lang: globalLang } = useLanguage();
  const [lang, setLang] = useState(globalLang === "es" ? "es" : "en");

  useEffect(() => {
    setLang(globalLang === "es" ? "es" : "en");
  }, [globalLang]);

  return (
    <section id="notice" className="relative bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5, ease }}
          className="overflow-hidden rounded-3xl border border-[color:var(--border-subtle)] bg-white shadow-[var(--shadow-float)]"
          data-testid="service-notice-card"
        >
          <NoticeBody content={noticeContent} lang={lang} setLang={setLang} />
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceNotice;
